module.exports = __webpack_public_path__ + "img/favicon.bb2291a2.png";